module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Layout_404":{"hooks.onStartRendering":[{"value":function () {
var txtLogo = fox.objectGet(fox.dictionary, 'phrases.logoText.default');
if (txtLogo) {
var length = fox.trim(txtLogo.replace(new RegExp('&nbsp;', "g"), String.fromCharCode(160))).length;
if (length > 20) {
this.setTemplateOptions({
showDefaultMobileLogo: true
})
}
}
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107013},"path":"~.Layout_404","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/layout/404.js
// module id = 958
// module chunks = 4